/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('MessageTemplateNew', function($scope, $stateParams, $rootScope, templateService,
    recipientService, _$editmode, mailboxService) {

    _$editmode.turnOn();

    $scope.id = $stateParams.id;

    $scope.tab = {
        "selected": 0,
        "change": function(kind, form) {
            var result = true;
            if ($scope.tab.editable && typeof form != "undefined") {
                result = $scope.check(form);
            }
            if (result)
                $scope.tab.selected = kind == 'next' ? $scope.tab.selected + 1 : $scope.tab.selected - 1;
        },
        "title": $scope.id ? "Edycja szablonu wiadomości" : "Nowy szablon wiadomości",
        "kind": "template",
        "button": "Zapisz",
        "editable": true,
        "details": false
    };

    $scope.data = {
        "categories": [],
        "notifications": [],
        "copy_template_name": "",
        "subunit": false,
        "subunit_id": false,
        "emailsettings": {},
        "available_notifications": [],
        "languages": []
    };

    $scope.notavailable = {
        "sms": false,
        "mobile": true,
        "email": false,
        "epuap": false,
        "available_to": true
    };

    $scope.mobileNotificationId;

    $scope.$watch("row.content.only_sms", function(value) {
        if (parseInt(value, 10) == 1) {
            $scope.notavailable.email = true;
            $scope.notavailable.epuap = true;
            $scope.notavailable.mobile = true;

            for (var i = 0; i < $scope.data.notifications.length; i++) {
                if ($scope.data.notifications[i].symbol == "sms") {
                    $scope.row.content.notification = ["" + $scope.data.notifications[i].id];
                    $scope.row.priority = [$scope.data.notifications[i].id];
                }
            }
        } else {
            $scope.notavailable.email = $scope.row.content.long_msg == "";
            $scope.notavailable.epuap = $scope.row.content.long_msg == "";
            $scope.notavailable.mobile = $scope.row.content.mobile_msg == "";
        }
    });

    $scope.$watch("row.content.long_msg", function(value) {
        $scope.notavailable.email = (value == "");
        $scope.notavailable.epuap = (value == "");
    });

    $scope.$watch("row.content.mobile_msg", function(value) {
        $scope.notavailable.mobile = (value == "");
    });

    $scope.search = {
        "clearButton": false,
        "clearButtonPressed": false,
        "changeKind": function() {
            $scope.row.content.filter.age = '';
        },
        "clear": function() {
            if ($scope.row.content.filter.all) {
                $scope.row.content.filter = {
                    'all': 1,
                    'kind': 0,
                    //'sex': 0
                };
                $scope.search.run();
            }
        },
        clearFilters: function() {
            if ($scope.row.content.filter.kind == 'advanced') {
                $scope.search.empty();
                $scope.search.clearButton = false;
                $scope.search.clearButtonPressed = true;
            }
        },
        "empty": function() {
            $scope.row.content.filter.name = "";
            $scope.row.content.filter.sex = '';
            $scope.row.content.filter.name = '';
            $scope.row.content.filter.surname = '';
            $scope.row.content.filter.county = '';
            $scope.row.content.filter.comunity = '';
            $scope.row.content.filter.street = '';
            $scope.row.content.filter.city = '';
            $scope.row.content.filter.postcode = '';
            $scope.row.content.filter.age = '';
            $scope.row.content.filter.age_before = '';
            $scope.row.content.filter.age_after = '';
            if (!$scope.data.subunit)
                $scope.row.content.unit = [];

            $scope.autocompletes = {
                "county": [],
                "city": [],
                "comunity": [],
                "street": []
            };
        },
        "list": {},
        "run": function() {
            var params = angular.copy($scope.row.content.filter);
            var units = angular.copy($scope.row.content.unit);

            params.active = 1;
            params.verified = 1;
            params.contact = 1;

            if ($scope.autocompletes.city.length > 0)
                params.city = _.map($scope.autocompletes.city, 'name').join();
            if ($scope.autocompletes.county.length > 0)
                params.county = _.map($scope.autocompletes.county, 'name').join();
            if ($scope.autocompletes.comunity.length > 0)
                params.comunity = _.map($scope.autocompletes.comunity, 'name').join();
            if ($scope.autocompletes.street.length > 0)
                params.street = _.map($scope.autocompletes.street, 'name').join();

            if ($scope.data.subunit)
                params.unit_id = $scope.data.subunit_id;
            else if (units.length > 0)
                params.unit_id = units.join();

            var promise = recipientService.list(1, params);
            promise.then(
                function(payload) {
                    $scope.search.list = payload.data;
                },
                function(errorPayload) {
                    $rootScope.notification.show('error', 'Błąd ładowania odbiorców');
                });
        },
        "showClearButton": function() {
            if ($scope.listReady && $scope.row.content.filter.kind == 'advanced' && !$scope.search.clearButtonPressed) {
                $scope.search.clearButton = true;
            } else {
                $scope.search.clearButtonPressed = false;
                $scope.search.clearButton = false;
            }
        }
    };

    $scope.$watch('row.content.filter', function(newValue, oldValue) {
        if (typeof newValue.kind != "undefined" && newValue.kind == oldValue.kind)
            $scope.search.showClearButton();
    }, true);
    $scope.$watch('row.content.unit', function() {
        $scope.search.showClearButton();
    }, true);
    $scope.$watch('autocompletes', function(newValue, oldValue) {
        if ((newValue.county.length > 0) ||
            (newValue.comunity.length > 0) ||
            (newValue.city.length > 0) ||
            (newValue.street.length > 0))
            $scope.search.showClearButton();
    }, true);


    $scope.row = {
        'name': '',
        'content': {
            'only_sms': false,
            'subject': '',
            'notification_category_id': '',
            'short_msg': '',
            'long_msg': '',
            'mobile_msg': '',
            'photo': '',
            'link': '',
            'lat': null,
            'lng': null,
            'filter': {
                'all': 1,
                'kind': 0,
                'age': ''
            },
            'attachment': [],
            'notification': [],
            'receiver': [],
            'unit': []
        },
        'priority': []
    };

    $scope.autocompletes = {
        "county": [],
        "city": [],
        "comunity": [],
        "street": []
    };

    $scope.check = function(form) {
        if (form.$valid) {
            return true;
        } else {
            angular.forEach(form.$error, function(field) {
                angular.forEach(field, function(f) {
                    f.$setDirty();
                    f.$setTouched();
                });
            });
            $rootScope.notification.show('error', 'Formularz nie został prawidłowo wypełniony');
        }
    };

    $scope.save = function(form) {
        var params = angular.copy($scope.row);
        params.send_date = $rootScope.formatDate(params.send_date);
        params.mobile_available = $rootScope.formatDate(params.mobile_available);

        params.content.filter.county = $scope.autocompletes.county.length > 0 ? _.map($scope.autocompletes.county, 'name').join() : "";
        params.content.filter.comunity = $scope.autocompletes.comunity.length > 0 ? _.map($scope.autocompletes.comunity, 'name').join() : "";
        params.content.filter.city = $scope.autocompletes.city.length > 0 ? _.map($scope.autocompletes.city, 'name').join() : "";
        params.content.filter.street = $scope.autocompletes.street.length > 0 ? _.map($scope.autocompletes.street, 'name').join() : "";

        var promise = $scope.id ? templateService.update($scope.id, params) : templateService.store(params);
        promise.then(
            function(payload) {
                if (payload.data.code == 1) {
                    if ($scope.upload.photo.data != "" || $scope.upload.attachment.data.length > 0) {
                        promise = mailboxService.upload({
                            "id": $scope.id ? $scope.id : payload.data.id,
                            "photo": $scope.upload.photo.data,
                            "attachment": $scope.upload.attachment.data,
                            "kind": $scope.tab.kind == 'template' ? 'template' : 'mailbox'
                        }, function() {
                            $rootScope.notification.showAfterRedirect('message_templates', {}, 'success', "Zmiany zostały zapisane");
                        }, function() {
                            $rootScope.notification.show('error', 'Wystąpił błąd przy próbie uploadu plików');
                        });
                    } else {
                        $rootScope.notification.showAfterRedirect('message_templates', {}, 'success', payload.data.msg);
                    }
                } else {
                    $rootScope.notification.show('error', payload.data.msg);
                }
            });
    };

    $scope.listReady = false;
    $scope.init = function() {
        var promise = $scope.id ? templateService.edit($scope.id) : templateService.create();
        promise.then(
            function(payload) {
                $rootScope.filters = payload.data.filters;

                $scope.data.categories = payload.data.categories;
                $scope.search.list = payload.data.list;
                $scope.data.notifications = payload.data.notifications;
                $scope.data.available_notifications = payload.data.available_notifications;
                $scope.data.subunit = payload.data.subunit;
                $scope.data.subunit_id = payload.data.subunit_id;
                $scope.data.languages = payload.data.languages;

                if(payload.data.languages.length==1 && !$scope.id)
                  $scope.row.content.language_id = payload.data.languages[0].id;

                if ($scope.data.subunit) {
                    $scope.row.content.unit = [payload.data.subunit_id];
                }

                $scope.data.emailsettings = payload.data.emailsettings;

                if (typeof payload.data.receiver_list != "undefined")
                    $scope.data.receiver_list = payload.data.receiver_list;

                if ($scope.id) {
                    if (payload.data.row.length == 0) {
                        $rootScope.notification.showAfterRedirect('message_templates', {}, 'error', 'Wybrany szablon nie została odnaleziony');
                    } else {

                        $scope.row = payload.data.row;
                        $scope.row.mobile_available = $rootScope.formatDate($scope.row.mobile_available);
                        $scope.row.send_date = $rootScope.formatDate($scope.row.send_date);
                        $scope.row.priority = payload.data.row.content.notification;

                        for (var i = 0; i < $scope.data.notifications.length; i++) {
                            if ($scope.data.notifications[i].symbol == "mobile")
                                $scope.mobileNotificationId = "" + $scope.data.notifications[i].id;
                        }

                        if ($scope.row.content.mobile_msg != "")
                            $scope.notavailable.mobile = false;

                        var county = $scope.row.content.filter.county;
                        if (county) {
                            county = county.split(",");
                            for (var i = 0; i < county.length; i++) {
                                if (county[i] != "") {
                                    $scope.autocompletes.county.push({
                                        name: county[i],
                                        readonly: true
                                    });
                                }
                            }
                        }
                        var comunity = $scope.row.content.filter.comunity;
                        if (comunity) {
                            comunity = comunity.split(",");
                            for (var i = 0; i < comunity.length; i++) {
                                if (comunity[i] != "") {
                                    $scope.autocompletes.comunity.push({
                                        name: comunity[i],
                                        readonly: true
                                    });
                                }
                            }
                        }
                        var city = $scope.row.content.filter.city;
                        if (city) {
                            city = city.split(",");
                            for (var i = 0; i < city.length; i++) {
                                if (city[i] != "") {
                                    $scope.autocompletes.city.push({
                                        name: city[i],
                                        readonly: true
                                    });
                                }
                            }
                        }
                        var street = $scope.row.content.filter.street;
                        if (street) {
                            street = street.split(",");
                            for (var i = 0; i < street.length; i++) {
                                if (street[i] != "") {
                                    $scope.autocompletes.street.push({
                                        name: street[i],
                                        readonly: true
                                    });
                                }
                            }
                        }

                        if (typeof $scope.row != "undefined" && $scope.row.content.filter.age != null && $scope.row.content.filter.age != "") {
                            var age = $scope.row.content.filter.age.split("_");
                            if (age[0] == "date") {
                                $scope.row.content.filter.age_before = new Date($scope.row.content.filter.age_before);
                                if ($scope.row.content.filter.age_after != "")
                                    $scope.row.content.filter.age_before = new Date($scope.row.content.filter.age_before);
                            } else {
                                $scope.row.content.filter.age_before = parseInt($scope.row.content.filter.age_before, 10);
                                if ($scope.row.content.filter.age_after != "")
                                    $scope.row.content.filter.age_after = parseInt($scope.row.content.filter.age_after, 10);
                            }
                        }
                    }
                }

                $scope.listReady = true;
            },
            function(errorPayload) {
                $rootScope.notification.show('error', 'Wystąpił błąd podczas próby utworzenia nowego szablonu wiadomości');
            });
    };

    $scope.init();

    $scope.sendMethodChange = function() {
        if ($scope.row.priority.length != $scope.row.content.notification.length) {
            $scope.row.priority = angular.copy($scope.row.content.notification);
        }
    };

    $scope.priorityChange = function(index) {
        for (var i = 0; i < $scope.row.priority.length; i++) {
            if (i != index && $scope.row.priority[index] == $scope.row.priority[i]) {
                var find = "";
                for (var j = 0; j < $scope.row.content.notification.length; j++) {
                    if ($scope.row.priority.indexOf($scope.row.content.notification[j]) == -1)
                        find = $scope.row.content.notification[j];
                }
                $scope.row.priority[i] = find;
            }
        }
    };

    $scope.agechange = function() {
        $scope.row.content.filter.age_before = "";
        $scope.row.content.filter.age_after = "";
    };

    $scope.upload = {
        photo: {
            data: "",
            clear: function() {
                $scope.row.content.photo = '';
                $scope.upload.photo.data = '';
            },
            change: function(file) {
                if (file) {
                    $scope.row.content.photo = '';
                    $scope.upload.photo.data = file;
                }
            }
        },
        attachment: {
            counter: 0,
            data: [],
            remove: function(id) {
                var promise = mailboxService.removeattachment({
                    'mailbox_id': $scope.id,
                    'attachment_id': id,
                    "kind": $scope.tab.kind == 'template' ? 'template' : 'mailbox'
                });
                promise.then(
                    function(payload) {
                        if (payload.data.code) {
                            $scope.row.content.attachment = payload.data.attachment;
                            $rootScope.notification.show('success', payload.data.msg);
                        } else {
                            $rootScope.notification.show('error', payload.data.msg);
                        }
                    },
                    function(errorPayload) {
                        $rootScope.notification.show('error', 'Wystąpił błąd podczas próby usunięcia załącznika');
                    });
            },
            clear: function(index) {
                var newData = [];

                for (var i = 0; i < $scope.upload.attachment.data.length; i++) {
                    if (i != index) {
                        newData.push($scope.upload.attachment.data[i]);
                    } else {
                        $rootScope.notification.show('success', 'Załącznik został usunięty');
                    }
                }
                $scope.upload.attachment.data = newData;
            },
            change: function(files) {
                if (files) {
                    for (var i = 0; i < files.length; i++) {
                        $scope.upload.attachment.data.push(files[i]);
                        $scope.upload.attachment.counter++;
                    }
                }
            }
        }
    };
});
